import actions from "./actions";

const {FETCH_MOCK} = actions;
const initState = {
    mock: [],
};

const MockReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_MOCK:
            return {
                ...state,
                mock: data
            }
        default:
            return state;
    }
}

export default MockReducer;
